import React, { Component } from 'react';
import {ref} from '../../config/firebase';

export default class Skills extends Component {

	constructor(props) {
		super(props);
		this.state = {
			itemsIT: [],
			itemsMgmt: []
		};

		this.dbItems = ref.child('skills');
	}

	componentDidMount() {
		this.dbItems.on("value", snapshot => {
			var itemsIT = [];
			var itemsMgmt = [];


			snapshot.child("it").forEach(function(childSnapshot) {

				var item = childSnapshot.val();

				item['.key'] = childSnapshot.key;

				itemsIT.push(item);

			});

			snapshot.child("mgmt").forEach(function(childSnapshot) {

				var item = childSnapshot.val();

				item['.key'] = childSnapshot.key;

				itemsMgmt.push(item);

			});

			this.setState({
				itemsIT: itemsIT,
				itemsMgmt: itemsMgmt
			});

		});

	}

	mapSkills(lvl) {
		var aLvl = parseInt(lvl, 10);
		return (aLvl === 1) ? 'Good' : (aLvl === 2)? 'Fair' : 'Fluent';
	}

	mapStars(lvl) {
		var aLvl = parseInt(lvl, 10);

		if(aLvl === 1) {
			// Good
			return (
				<div className="panel-body">
					<i className="fa fa-star fa-2x gold"></i>
					<i className="fa fa-star-o fa-3x gold"></i>
					<i className="fa fa-star-o fa-2x gold"></i>
				</div>
			);
		}
		else if(aLvl === 2) {
			// Fair
			return (
				<div className="panel-body">
					<i className="fa fa-star fa-2x gold"></i>
					<i className="fa fa-star fa-3x gold"></i>
					<i className="fa fa-star-o fa-2x gold"></i>
				</div>
			);
		}

		// Fluent
		return (
			<div className="panel-body">
				<i className="fa fa-star fa-2x gold"></i>
				<i className="fa fa-star fa-3x gold"></i>
				<i className="fa fa-star fa-2x gold"></i>
			</div>
		);

	}

  render() {
  	var i = 0;
  	var _this = this;

    return (

      	<div className="container">
			<div className="row pt50 pb50">

				<div className="col-md-6 col-sm-6">
					<h2 className="pb20 white uppercase"><i className="fa fa-star"></i> IT Skills</h2>
					{
						this.state.itemsIT.map(function(item) {

							return (
								<div className="col-md-6 text-center" key={item['.key']}>
									<div className="panel panel-info">
										<div className="panel-heading">
											{item.skill_name}
										</div>
										{_this.mapStars(item.skill_lvl)}
										<div className="panel-footer">{_this.mapSkills(item.skill_lvl)}</div>
									</div>
								</div>
							);
						})
					}

				</div>
				<div className="col-md-6 col-sm-6">
					<h2 className="pb20 white uppercase"><i className="fa fa-star-o"></i> Management Skills</h2>

					{
						this.state.itemsMgmt.map(function(item) {

							return (
								<div className="col-md-6 text-center" key={item['.key']}>
									<div className="panel panel-info">
										<div className="panel-heading">
											{item.skill_name}
										</div>
										{_this.mapStars(item.skill_lvl)}
										<div className="panel-footer">{_this.mapSkills(item.skill_lvl)}</div>
									</div>
								</div>
							);
						})
					}

				</div>
			</div>
		</div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/guest/components/Skills.js